import styled from 'styled-components';

export const Header = styled.header`
  min-height: 10.6rem;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 3.1rem;

  position: sticky;
  top: 0;
`;

export const HeaderWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

export const HeaderLabel = styled.span`
  font-size: 2.5rem;
  color: #ffdf22;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.25px;
  margin-left: 0.6rem;
`;

export const Container = styled.div`
  overflow: auto;
`;

export const Table = styled.table`
  border-collapse: collapse;
  table-layout: fixed;
  width: 90%;

  @media (max-width: 768px) {
    table-layout: auto;
  }

  thead {
    tr {
      height: 6.1rem;
      th {
        color: #ffdf22;
        background: black;
        font-weight: 900;
        font-size: 1.7rem;
        text-align: left;
        padding: 0 3rem;
      }
    }
  }

  tbody {
    tr {
      height: 7rem;
      td {
        color: #fff;
        font-size: 1.7rem;
        text-align: left;
        padding: 0 3rem;
      }
    }
  }

  th,
  td {
    border: 1px solid #707070;
  }
`;
